import React, { Component } from 'react'
import Input from './Input'
/**
 *
 * Takes min and max as props to define a range of valid inputs
 *
 * @class RangeInput
 * @extends {Component}
 */
class RangeInput extends Component {
  onChange = (value) => {
    const { onChange } = this.props
    if(onChange) onChange(value)
  }

  isValid() {
    const {
      value,
      min,
      max
    } = this.props

    let errorText = `Input value must lay between ${min} and ${max}`

    const validRange = value <= max && value >= min

    if (validRange)
      errorText = ''

    return errorText
  }

  render() {
    const error = this.isValid()

    return (
      <Input
        type='number'
        hint={this.props.hint}
        value={this.props.value}
        error={error}
        onChange={this.onChange}
      />
    )
  }
}

export default RangeInput
